import { jsx as w } from "react/jsx-runtime";
const E = 21, e = "currentColor", g = "0 0 24 24", d = ({
  size: t = E,
  style: o,
  className: r,
  viewBox: n = g,
  children: s,
  color: c = e,
  role: a,
  dataAnchor: h
}) => /* @__PURE__ */ w(
  "svg",
  {
    width: t,
    height: t,
    viewBox: n,
    style: o,
    color: c,
    className: r,
    role: a,
    "data-anchor": h,
    xmlns: "http://www.w3.org/2000/svg",
    children: s
  }
);
export {
  e as DEFAULT_COLOR,
  E as DEFAULT_SIZE,
  g as DEFAULT_VIEWBOX,
  d as default
};
